<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>UserSubscription</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Users'}">Users</router-link>
              </li>
              <li class="breadcrumb-item active">User Subscription</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <router-link :to="{name: 'Users'}" type="button" tabindex="0" class="btn btn-info"><i
              class="fa fa-arrow-left"></i>Back
            </router-link>
            <!--<div class="card-tools">
              <router-link :to="{name: 'UserAdd'}" class="btn btn-success" v-if="_.isEmpty(list)">
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>-->
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Subscription Service</th>
                  <th>Subscription Status</th>
                  <th>Balance</th>
                  <th class="text-right">Action</th>
                </tr>
                </thead>
                <tbody class="users-list">
                  <tr v-for="(val, index) in list" :key="index">
                    <td>{{ val.service.name }}</td>
                    <td>{{ val.is_subscribed }}</td>
                    <td>{{ val.balance }}</td>
                    <td class="text-right">
                      <b-button v-b-modal.add-balance-modal class="btn btn-danger"
                                @click="setSubscriptionCatID(val.subscription_category_id)">
                        <i class="fas fa-dollar-sign"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal
      id="add-balance-modal" ref="add-balance-modal" title="Add Balance"
      @show="resetModal" @hidden="resetModal" @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Balance"
          label-for="name-input"
          invalid-feedback="Invalid Amount"
          :state="additional_balance_state"
        >
          <b-form-input
            id="name-input"
            v-model="additional_balance"
            type="number"
            min="1"
            max="99999999999999999999"
            :state="additional_balance_state"
            required
          />
        </b-form-group>
      </form>
    </b-modal>

  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'UserList',
  metaInfo: {
    title: 'User Subscriptions | Dotlines'
  },
  data: () => ({
    list: {},
    additional_balance: 0,
    additional_balance_state: null,
    subscription_category_id: null,
    is_loading: false
  }),
  mounted: function () {
    this.getSubscriptions()
  },
  methods: {
    setSubscriptionCatID (catID) {
      this.subscription_category_id = catID
    },

    handleSubmit () {
      this.$refs['add-balance-modal'].show()

      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names

      this.is_loading = true
      const userid = this.$route.params.id
      const api_url = '/admin_users/' + userid + '/subscriptions/add-balance'
      axios.post(api_url, {
        additional_balance: this.additional_balance,
        subscription_category_id: this.subscription_category_id
      }).then(response => {
        this.$toaster.success(response.data.message);
        this.getSubscriptions()
      }).catch(error => {
        this.$toaster.error(error.response.data.message);
      }).finally(() => {
        this.is_loading = false
      })

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('add-balance-modal')
      })
    },

    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.additional_balance_state = valid
      return valid
    },
    resetModal () {
      this.additional_balance = ''
      this.additional_balance = null
    },
    handleOk (bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    getSubscriptions () {
      this.is_loading = true
      const userid = this.$route.params.id
      const api_url = '/admin_users/' + userid + '/subscriptions'
      axios.get(api_url).then(response => {
        this.list = response.data
      }).catch(error => {
        console.log('getSubscriptions: ', error.response)
      }).finally(() => {
        this.is_loading = false
      })
    }
  }
}
</script>
